import { create } from 'zustand';

const useCMSStore = create((set, get) => ({
  // State
  menus: {},
  pages: {},
  isLoading: false,
  error: null,
  currentMenuType: 'TOP_BAR', // TOP_BAR, ADMIN_TOP_BAR, PROFILE_SIDEBAR

  // Actions
  setCurrentMenuType: (menuType) => set({ currentMenuType: menuType }),

  fetchMenu: async (menuType, accessToken = null, profileId = null, apparentRoleId = null) => {
    set({ isLoading: true, error: null });

    try {
      const headers = {
        'Content-Type': 'application/json',
      };

      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      // Build URL with optional parameters
      let url = `/api/cms/menu?menuType=${menuType}`;
      if (profileId) {
        url += `&profileId=${profileId}`;
      }
      if (apparentRoleId !== null && apparentRoleId !== undefined) {
        url += `&apparentRoleId=${apparentRoleId}`;
      }

      const response = await fetch(url, {
        headers,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch menu');
      }

      // Cache key includes profileId for PROFILE_SIDEBAR menus
      const cacheKey = profileId ? `${menuType}_${profileId}` : menuType;

      set((state) => ({
        menus: {
          ...state.menus,
          [cacheKey]: data.items,
        },
        isLoading: false,
      }));

      return { success: true, items: data.items };
    } catch (error) {
      set({
        isLoading: false,
        error: error.message,
      });
      return { success: false, error: error.message };
    }
  },

  fetchPage: async (slug, accessToken = null) => {
    set({ isLoading: true, error: null });

    try {
      const headers = {
        'Content-Type': 'application/json',
      };

      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      const response = await fetch(`/api/cms/page/${slug}`, {
        headers,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch page');
      }

      set((state) => ({
        pages: {
          ...state.pages,
          [slug]: {
            page: data.page,
            revision: data.revision,
            paragraphs: data.paragraphs,
          },
        },
        isLoading: false,
      }));

      return { success: true, data };
    } catch (error) {
      set({
        isLoading: false,
        error: error.message,
      });
      return { success: false, error: error.message };
    }
  },

  getMenu: (menuType) => {
    const state = get();
    return state.menus[menuType] || [];
  },

  getPage: (slug) => {
    const state = get();
    return state.pages[slug] || null;
  },

  clearError: () => set({ error: null }),
}));

export { useCMSStore };
